import { apiDelete, apiGet, apiPost, apiPut } from "./api-service";

export async function getAll() {
    try {
        const response = await apiGet('core', `ppe`);
        return response;
    } catch (e) { }
}

export async function PPEAddAPI(newDetails: any) {
    try {
        const response = await apiPost('core', `ppe`, newDetails);
        return response;
    } catch (e) { }
}

export async function PPEImportAPI(newDetails: any) {
    try {
        const response = await apiPost('core', `ppe-import`, newDetails);
        return response;
    } catch (e) { }
}

export async function PPEUpdate(id: string, newDetails: any) {
    try {
        const response = await apiPut('core', `ppe/${id}`, newDetails);
        return response;
    } catch (e) { }
}

export async function removePPE(id: any) {
    try {
        return await apiDelete('core', `ppe/${id}`);
    } catch (e) { }
}


export async function PPEEmployeeAdd(body: any) {
    try {
        const response = await apiPost('core', `ppe-employee`, body);
        return response;
    } catch (e) { }
}

export async function PPEEmployeeUpdate(id: string, body: any) {
    try {
        const response = await apiPut('core', `ppe-employee/${id}`, body);
        return response;
    } catch (e) { }
}

export async function PPEEmployeeRemove(id: any) {
    try {
        return await apiDelete('core', `ppe-employee/${id}`);
    } catch (e) { }
}